import { useMutation, useQuery } from "@tanstack/react-query";
import {
  Button,
  Image,
  Input,
  message,
  Modal,
  Table,
  Tabs,
  Typography,
} from "antd";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  acceptUploadRequest,
  deleteUploadRequest,
  getUploadRequests,
  rejectUploadContentRequest,
} from "../utils/api";

const UploadRequest = () => {
  const { data, isFetching, refetch } = useQuery({
    queryKey: ["uploadrequests"],
    queryFn: getUploadRequests,
  });
  console.log(isFetching);

  const items = [
    {
      key: "1",
      label: "Pending",
      children: (
        <UploadTable
          data={data?.filter((d) => d.status === "Pending")}
          isLoading={isFetching}
          refetch={refetch}
        />
      ),
    },
    {
      key: "2",
      label: "Approved",
      children: (
        <UploadTable
          data={data?.filter((d) => d.status === "Approved")}
          isLoading={isFetching}
          refetch={refetch}
        />
      ),
    },
    {
      key: "3",
      label: "Permanent Reject",
      children: (
        <UploadTable
          data={data?.filter((d) => d.status === "Permanent Reject")}
          isLoading={isFetching}
          refetch={refetch}
        />
      ),
    },
    {
      key: "4",
      label: "Reject",
      children: (
        <UploadTable
          data={data?.filter((d) => d.status === "Reject")}
          isLoading={isFetching}
          refetch={refetch}
        />
      ),
    },
  ];
  return (
    <div
      style={{
        padding: 24,
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 20,
        }}
      >
        <Typography style={{ fontSize: 20, fontWeight: 600, marginBottom: 10 }}>
          Upload Request
        </Typography>
      </div>
      <Tabs defaultActiveKey="1" items={items} />
    </div>
  );
};

export default UploadRequest;

const UploadTable = ({ data, isLoading, refetch }) => {
  console.log(data);
  const [selected, setSelected] = React.useState(null);
  return (
    <div
      style={{
        display: "flex",
        gap: 20,
      }}
    >
      <Table
        style={{ width: "30%" }}
        dataSource={data}
        loading={isLoading}
        scroll={{ x: true }}
        columns={[
          {
            title: "Actions",
            dataIndex: "_id",
            render(value, record) {
              return (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-around",
                    flexDirection: "column",
                    gap: 10,
                    visibility:
                      record.status !== "Pending" ? "hidden" : "visible",
                  }}
                >
                  <AcceptReject
                    type={"Approve"}
                    record={record}
                    refetch={refetch}
                  />
                  <AcceptReject
                    type={"Reject"}
                    record={record}
                    refetch={refetch}
                  />
                  <AcceptReject
                    type={"Permanent Reject"}
                    record={record}
                    refetch={refetch}
                  />
                  <AcceptReject
                    type={"Delete"}
                    record={record}
                    refetch={refetch}
                  />
                </div>
              );
            },
          },
          {
            title: "Name",
            dataIndex: "name",
            render(value, record) {
              return (
                <Button
                  onClick={() => setSelected(record)}
                  type={selected?._id === record._id ? "primary" : "default"}
                >
                  {value}
                </Button>
              );
            },
          },
        ]}
      />
      {selected && (
        <div
          style={{
            width: "70%",
            display: "flex",
            flexDirection: "column",
            gap: 20,
          }}
        >
          <Typography style={{ fontSize: 20, fontWeight: 600 }}>
            Description
          </Typography>
          <Image
            style={{
              width: "100%",
              aspectRatio: "16/9",
              objectFit: "contain",
              maxHeight: 300,
            }}
            src={selected?.cover}
          />
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography style={{ fontSize: 16, fontWeight: 600 }}>
              Release Year
            </Typography>
            <Typography style={{ fontSize: 16, fontWeight: 600 }}>
              {selected?.releaseYear}
            </Typography>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography style={{ fontSize: 16, fontWeight: 600 }}>
              Video Type
            </Typography>
            <Typography style={{ fontSize: 16, fontWeight: 600 }}>
              {selected?.videoType}
            </Typography>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography style={{ fontSize: 16, fontWeight: 600 }}>
              Amount
            </Typography>
            <Typography style={{ fontSize: 16, fontWeight: 600 }}>
              {selected?.amount}
            </Typography>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography style={{ fontSize: 16, fontWeight: 600 }}>
              Payment Status
            </Typography>
            <Typography style={{ fontSize: 16, fontWeight: 600 }}>
              {selected?.paymentStatus}
            </Typography>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography style={{ fontSize: 16, fontWeight: 600 }}>
              Artist
            </Typography>
            <Typography style={{ fontSize: 16, fontWeight: 600 }}>
              {selected?.artist
                ?.map((a) => {
                  return a.name;
                })
                .join(", ")}
            </Typography>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography style={{ fontSize: 16, fontWeight: 600 }}>
              Featuring Artist
            </Typography>
            <Typography style={{ fontSize: 16, fontWeight: 600 }}>
              {selected?.featuringArtist
                ?.map((a) => {
                  return a.name;
                })
                .join(", ")}
            </Typography>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography style={{ fontSize: 16, fontWeight: 600 }}>
              Audio
            </Typography>
            <Link
              to={selected?.audio}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button type="link">View</Button>
            </Link>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography style={{ fontSize: 16, fontWeight: 600 }}>
              Video
            </Typography>
            <Link
              to={selected?.video}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button type="link">View</Button>
            </Link>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography style={{ fontSize: 16, fontWeight: 600 }}>
              User
            </Typography>
            <Typography style={{ fontSize: 16, fontWeight: 600 }}>
              {selected?.user?.name}
            </Typography>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography style={{ fontSize: 16, fontWeight: 600 }}>
              Email
            </Typography>
            <Typography style={{ fontSize: 16, fontWeight: 600 }}>
              {selected?.user?.email}
            </Typography>
          </div>
        </div>
      )}
    </div>
  );
};

const AcceptReject = ({ type, record, refetch }) => {
  const [remark, setRemark] = useState("");
  const { mutate: reject, isLoading: isLoading2 } = useMutation(
    async (status) =>
      await rejectUploadContentRequest({
        requestId: record._id,
        status: type,
        remark: remark,
        user: record.user._id,
      }),
    {
      onSuccess: () => {
        message.success(type);
        refetch();
        setOpen(false);
        setRemark("");
      },
    }
  );

  const { mutate: approve, isLoading: isLoading3 } = useMutation({
    mutationFn: async (status) =>
      await acceptUploadRequest({
        requestId: record._id,

        uploadedBy: record.user._id,
      }),
    onSuccess: () => {
      message.success(type);
      refetch();
      setOpen(false);
      setRemark("");
    },
  });

  const { mutate: deleteR, isLoading: isLoading } = useMutation({
    mutationFn: async () => await deleteUploadRequest(record?._id),
    onSuccess: () => {
      message.success(type);
      refetch();
    },
  });

  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        type={"primary"}
        danger={type !== "Approve"}
        loading={isLoading || isLoading2 || isLoading3}
        onClick={() =>
          type === "Delete"
            ? deleteR()
            : type === "Reject" || type === "Permanent Reject"
            ? setOpen(true)
            : approve()
        }
      >
        {type}
      </Button>

      <Modal
        title="Are you sure you want to delete this request?"
        open={open}
        onOk={() => {
          reject();
        }}
        confirmLoading={isLoading || isLoading2}
        onCancel={() => setOpen(false)}
      >
        <Input
          placeholder="Reason"
          onChange={(e) => setRemark(e.target.value)}
          value={remark}
        />
      </Modal>
    </>
  );
};
